/**
 * Card Component
 * Container for content with elevated surface styling
 */

import React from 'react';

const Card = ({
  children,
  className = '',
  hoverable = false,
  glass = false,
  ...props
}) => {
  const baseStyles = 'rounded-lg border border-[#2D3748] transition-all duration-200 ease-in-out';
  
  const glassStyles = glass 
    ? 'bg-[#1A1D23]/50 backdrop-blur-md' 
    : 'bg-[#1A1D23]';
  
  const hoverStyles = hoverable 
    ? 'hover:border-[#128C7E] hover:shadow-lg hover:shadow-[#128C7E]/10' 
    : '';

  return (
    <div
      className={`${baseStyles} ${glassStyles} ${hoverStyles} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;
